module.exports = __webpack_public_path__ + "img/chi-siamo.94d6f862.jpg";